"use client";

import React from "react";
import { Plus, Minus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How do I start the patient navigation process?",
  answer: "We begin with a comprehensive initial consultation to understand your medical history and current challenges. This allows us to create a personalized roadmap for your care journey, identifying immediate priorities and long-term goals."
}, {
  question: "What is included in family support services?",
  answer: "Our family support provides guidance on caregiving responsibilities, emotional support for loved ones, and practical resources to help families manage the complexities of a chronic illness while maintaining their own well-being."
}, {
  question: "Do you coordinate directly with my medical team?",
  answer: "Yes, we act as a professional bridge between you and your healthcare providers. We ensure clear communication, attend appointments when necessary, and help synchronize all aspects of your treatment plan for better outcomes."
}, {
  question: "Can you help with insurance and medical billing?",
  answer: "While we don't process claims directly, we help you understand your coverage, organize complex medical bills, and identify resources for financial assistance or potential insurance appeals to reduce your administrative burden."
}, {
  question: "Are your navigation services available remotely?",
  answer: "Absolutely. We offer virtual consultations and support sessions via secure, HIPAA-compliant video platforms. This allows us to assist families and patients regardless of their physical location or mobility constraints."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="177260" id="frequently-asked-questions" className="bg-background py-24 md:py-32 px-6 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16 md:mb-24">
          <span className="text-chart-2 uppercase tracking-[0.15em] text-xs font-medium mb-6 block">
            Support
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-light text-foreground tracking-tight">
            Navigating Your Concerns
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group border-b border-border last:border-0">
              <AccordionTrigger className="hover:no-underline py-6 md:py-8 [&>svg.lucide-chevron-down]:hidden">
                <span className="flex-1 text-left font-serif font-light text-2xl md:text-[28px] tracking-tight text-foreground pr-8">
                  {faq.question}
                </span>
                <div className="relative size-6 shrink-0 flex items-center justify-center">
                  <Plus className="absolute size-6 stroke-[2px] text-chart-2 transition-all duration-500 ease-out group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                  <Minus className="absolute size-6 stroke-[2px] text-chart-2 transition-all duration-500 ease-out -rotate-90 opacity-0 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="pt-2 pb-10 text-lg font-sans leading-[1.6] text-foreground/80 transform transition-all duration-700 ease-out translate-y-5 opacity-0 group-data-[state=open]:translate-y-0 group-data-[state=open]:opacity-100">
                  {faq.answer}
                </div>
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}